<script>
import SuccessIcon from "@/assets/icons/SuccessIcon.svg"

export default {
  name: "FailedToUpdateModal",
  props: {
    value: {
      Boolean, default() {
        return false
      }
    },
    modelId: {
      String, default() {
        return null
      }
    },
    name: {
      String, default() {
        return null
      }
    },
  },
  data() {
    return {
      SuccessIcon,
    }
  },
  computed: {
    modalTitleMessage() {
      return this.lodash.startCase(this.$t('Success to update {something} [ID {id}]', {
        something: this.name,
        id: this.modelId
      }))
    },
  },
}
</script>

<template>
  <b-modal
      v-model="value"
      centered
      hide-header
      hide-footer
      size="md"
      no-close-on-backdrop
  >
    <div class="text-center">
      <img class="mb-2" :src="SuccessIcon" alt="Success Icon"/>
      <h3>{{ modalTitleMessage }}</h3>
    </div>
  </b-modal>
</template>

<style scoped lang="scss">
p {
  font-size: 14px;
  line-height: 24px;
}

button {
  font: 600 12px/16px Lato, sans-serif;
}
</style>